import SkeletonNode from "antd/es/skeleton/Node";
import "./project-objects-skeleton.scss";

export const ProjectObjectsSkeleton = () => {
  return (
    <div className="project-objects-skeleton">
      <SkeletonNode
        active
        style={{ width: 128, height: 22, marginBottom: 17 }}
      />
      <SkeletonNode
        active
        style={{ width: 256, height: 32, marginBottom: 12 }}
      />
      <SkeletonNode
        active
        style={{ width: "100%", height: 50, marginBottom: 32 }}
      />
      <SkeletonNode style={{ width: "100%", height: "20vh" }} />
    </div>
  );
};
